import { KEY_REDUCER_SHOP } from "./constants";

export const selectorShopBooks = (state) => state[KEY_REDUCER_SHOP].shopBooks;
export const selectorShopBooksAll = (state) => state[KEY_REDUCER_SHOP].allShopBooks;
export const selectorShopIds = (state) => state[KEY_REDUCER_SHOP].shopIds;
export const selectorPendingIds = (state) => state[KEY_REDUCER_SHOP].pendingIds;
export const selectorPackageIds = (state) => state[KEY_REDUCER_SHOP].packageIds;
export const selectorLoadingPackages = (state) => state[KEY_REDUCER_SHOP].loadingPackages;
export const selectorShopPackages = (state) => state[KEY_REDUCER_SHOP].shopPackages;
export const selectorShopIsPackagesFetched = (state) => state[KEY_REDUCER_SHOP].isPackagesFetched;

